export const STANDARD_LICENSE_MONTHLY_FEE = 2000;
export const CARD_SUBSCRIPTION_TAX_RATE = 0.1;
